// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-hidden-file
{
    position: absolute;
    opacity: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
}

.video-common-form .short-bio-form textarea {
    padding: 5px 10px 10px 10px;
}
::ng-deep .user-prompt-modal .mat-mdc-dialog-surface {
  padding: 0 !important;
}
.add-user-btn {
    background-color: #5e3ace;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.video-common-form .stepbystep-form-area img{
    height: 44px;
}
.add-user-btn img {
    width: 34px;
    margin-bottom: 0 !important;
}
.uploaded-img img {
    margin-bottom: 0;
    width: 50px;
    border-radius: 10px;
}
#imageGenerateModal p {
    font-size: 12px;
    color: #8d8d8d;
}
.remove-uploaded {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #f44336;
    border-radius: 100%;
    cursor: pointer;
    top: -6px;
    right: -6px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}
.remove-uploaded img {
    width: 14px;
    height: 14px;
    filter: brightness(0) invert(1);
}
.generate-img {
    width: 100%;
    height: 400px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    padding: 10px;
}

.generate-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.video-common-btn {
    width: auto;
    /* margin-left: -15px; */
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/profileCompletion/profileCompletion.component.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,wBAAwB;AAC5B","sourcesContent":[".input-hidden-file\r\n{\r\n    position: absolute;\r\n    opacity: 0;\r\n    z-index: 9;\r\n    width: 100%;\r\n    height: 100%;\r\n    left: 0;\r\n    top: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.video-common-form .short-bio-form textarea {\r\n    padding: 5px 10px 10px 10px;\r\n}\r\n::ng-deep .user-prompt-modal .mat-mdc-dialog-surface {\r\n  padding: 0 !important;\r\n}\r\n.add-user-btn {\r\n    background-color: #5e3ace;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.video-common-form .stepbystep-form-area img{\r\n    height: 44px;\r\n}\r\n.add-user-btn img {\r\n    width: 34px;\r\n    margin-bottom: 0 !important;\r\n}\r\n.uploaded-img img {\r\n    margin-bottom: 0;\r\n    width: 50px;\r\n    border-radius: 10px;\r\n}\r\n#imageGenerateModal p {\r\n    font-size: 12px;\r\n    color: #8d8d8d;\r\n}\r\n.remove-uploaded {\r\n    position: absolute;\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: #f44336;\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    top: -6px;\r\n    right: -6px;\r\n    z-index: 10;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.remove-uploaded img {\r\n    width: 14px;\r\n    height: 14px;\r\n    filter: brightness(0) invert(1);\r\n}\r\n.generate-img {\r\n    width: 100%;\r\n    height: 400px;\r\n    border: 1px solid #e7e7e7;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n}\r\n\r\n.generate-img img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n.video-common-btn {\r\n    width: auto;\r\n    /* margin-left: -15px; */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
